import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { getSignatureTemplates } from "components/editor/upgrade-template";
import { useGetTemplatesQuery } from "generated/graphql";
import React, { useCallback, useMemo, useState } from "react";
import { getSanitizedMarkUpFromEmailBody } from "util/email";

interface SignaturePreviewProps {
    className?: string;
}

export const SignaturePreview: React.FC<SignaturePreviewProps> = props => {
    const { className } = props;
    const templatesQuery = useGetTemplatesQuery();
    const [expanded, setExpanded] = useState<boolean>(false);

    const defaultSignature = useMemo(() => {
        if (!templatesQuery.data?.getTemplates?.templates) {
            return null;
        }
        const signatures = getSignatureTemplates(
            templatesQuery.data.getTemplates.templates,
        );
        return signatures.find(s => s.isDefaultSignature) || null;
    }, [templatesQuery.data]);

    const toggleExpanded = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setExpanded(v => !v);
    }, []);

    if (!defaultSignature) {
        return null;
    }

    return (
        <div className={`-mt-2 ${className || ""}`}>
            <button
                onClick={toggleExpanded}
                className="flex items-center justify-center gap-2 w-full py-2 px-3 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded transition-colors">
                <span className="text-sm font-medium">
                    Preview Your Default Signature
                </span>
                <ChevronDownIcon
                    className={`w-4 h-4 transform transition-transform duration-200 ${
                        expanded ? "rotate-180" : "rotate-0"
                    }`}
                />
            </button>
            {expanded ? (
                <div className="mt-2 pt-2 border-t border-b border-gray-400">
                    <div
                        className="preview-email-body-content selectable-texts "
                        dangerouslySetInnerHTML={getSanitizedMarkUpFromEmailBody(
                            defaultSignature.body,
                        )}
                    />
                </div>
            ) : null}
        </div>
    );
};
